import { ReturnsLineItem as ModelsLineItem } from '@itsrever/rever-api'
import ProductPreview from '@/components/ProductPreview'
import { useTranslate } from '@/hooks'
import { ReturnsNonReturnableItemReasonEnum } from '@itsrever/rever-api'
import { useAppSelector } from '@/redux/hooks'

interface NonReturnableProductCardProps {
    product: ModelsLineItem
}

export const NonReturnableProductCard: React.FC<
    NonReturnableProductCardProps
> = ({ product }) => {
    const { translate } = useTranslate()
    const group = useAppSelector(
        (store) => store.settingsApi.settings.response.ecommerce_group
    )
    const isHoff = group === 'hoff'
    const isMisako = group === 'misako'

    function getEnumValueIndex(
        enumObj: Record<string, string>,
        targetValue: string
    ): number {
        return Object.values(enumObj).indexOf(targetValue)
    }

    function findReason() {
        if (
            product.non_returnable_items &&
            product.non_returnable_items.length > 0
        ) {
            const reasonIndex = getEnumValueIndex(
                ReturnsNonReturnableItemReasonEnum,
                product.non_returnable_items[0].reason ?? ''
            )
            return translate(`item_selection_reason${reasonIndex}`)
        }
        return 'Non returnable'
    }
    const nonReturnableReason = findReason()

    if (isHoff) {
        return (
            <div className="relative border-t-1 border-solid border-black p-2">
                <ProductPreview product={product} disabled />
                <p
                    className="absolute bottom-3 right-1 mr-1 mt-2 rounded-lg border border-solid border-neutral-500 bg-white px-3 py-1 text-right text-xs text-neutral-500"
                    dangerouslySetInnerHTML={{
                        __html: nonReturnableReason
                    }}
                />
            </div>
        )
    }

    if (isMisako) {
        return (
            <div className="flex flex-wrap items-end justify-between gap-4 rounded-lg bg-white p-2">
                <ProductPreview product={product} disabled />
                <p
                    className="mr-auto w-fit max-w-96 shrink-0 rounded-xl border border-solid border-yellow-500 bg-white px-3 py-1 text-right text-xs text-yellow-500"
                    dangerouslySetInnerHTML={{
                        __html: nonReturnableReason
                    }}
                />
            </div>
        )
    }

    return (
        <div className="flex flex-wrap items-end justify-between gap-4 rounded-lg bg-white p-2">
            <ProductPreview product={product} disabled />
            <p
                className="ml-auto w-fit max-w-96 shrink-0 rounded-xl border border-solid border-yellow-500 bg-white px-3 py-1 text-right text-xs text-yellow-500"
                dangerouslySetInnerHTML={{
                    __html: nonReturnableReason
                }}
            />
        </div>
    )
}
